module.exports = __webpack_public_path__ + "img/about_img.8cb1200d.png";